export enum TrimSizeTypeEnum{
    Width ='Width',
    Dimension = 'Dimension',
    // Length = 'Length',
    NA = 'NA'
}